export interface PromoCode {
  message?: string;
  messageKey?: string;
  balanceAmount?: string;
  discountPercentage?: string;
  isPrivate?: boolean;
}
